<template>
  <LoanForm :selectedProduct="selectedProduct" @submit="submitLoanApplication"
            :showEir="isShownEir" :showApr="isShownApr"
            :campaignText="$t('LoanFormPage.campaignConditionsNewCustomer')"/>
</template>

<script>
  import LoanForm from '@shared/components/LoanForm'
  import store from '@shared/store'

  export default {
    name: 'NewCustomerLoanFormPage',
    components: { LoanForm },
    props: ['showEir', 'showApr'],
    data () {
      return {
        selectedProduct: store.getSelectedProduct() || { ...this.$configuration.basic }
      }
    },
    computed: {
      isShownApr() {
        return this.showApr === undefined ? true : this.showApr
      },
      isShownEir() {
        return this.showEir === undefined ? false : this.showEir
      }
    },
    methods: {
      submitLoanApplication() {
        this.$router.push({ name: 'loan-step-contacts' })
      }
    }
  }
</script>
